import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { filter, take } from 'rxjs';
import { slideInOut } from '../../animations/slide-in-out.animation';
import { getWindow } from 'ssr-window';
import { opacityInOut } from '../../animations/opacity-in-out.animation';

@Component({
  selector: 'a-select-input',
  templateUrl: 'a-select-input.component.html',
  styleUrls: ['a-select-input.component.scss'],
  animations: [slideInOut, opacityInOut]
})
export class ASelectInputComponent implements OnInit {

  @ViewChild('scrolledEl') scrolledEl: ElementRef | undefined;
  @ViewChild('selectEl') selectEl: ElementRef | undefined;
  @ViewChild('searchEl') searchEl: ElementRef | undefined;
  @Input() type = 'text';
  @Input() isSubmitted = true;
  @Input() label = '';
  @Input() grayBg = true;
  @Input() isOptional = false;
  @Input() items: any = null;
  @Input() searchActive = false;
  @Input() hideSelectedItem: any = false;
  @Input() control: FormControl = new FormControl();
  @Input() selectControl: FormControl = new FormControl();
  @Input() errorMessage = null;
  @Input() set isIncognito(val) {
    if (this.isAnonymous === null) {
      this.isAnonymous = val
    } else {
      val ? setTimeout(() => this.isAnonymous = val, 1000) : this.isAnonymous = val;
    }
  };
  @Output() onBlur = new EventEmitter<any>();

  selectedItem = null;
  showItems = false;
  inputFocused = false;
  openPositionTop = false;
  searchValue = null;
  initValue = null;
  initSelectValue = null;
  isAnonymous = null

  constructor() {
  }

  ngOnInit(): void {
    if (this.selectControl.value) {
      this.initSelectValue = this.selectControl.value;
      this.selectedItem = this.items.find(item => item.value === this.selectControl.value)
      this.selectControl.valueChanges.pipe(take(1)).subscribe(val => {
        this.selectedItem = this.items.find(item => item.value === val);
      });
    }
    if (this.control.value) {
      this.initValue = this.control.value;
    } else {
      // const controlSub = this.control.valueChanges.pipe(filter(data => !!data)).subscribe(val => {
      //   this.initValue = val;
      //   controlSub.unsubscribe();
      // });
    }
  }

  onFocus(val: boolean) {
    this.inputFocused = val;
    if (!val && this.control.value !== this.initValue) {
      this.onBlur.emit();
      this.isSubmitted = true;
      this.initValue = this.control.value;
    }
  }

  findResult(val: any) {
    this.searchValue = val;
    const index = this.items.findIndex((item: any) => item.label.toLowerCase().includes(val.toLowerCase()))
    if (index >= 0) {
      this.scrollToIndex(index);
    } 
  }

  clearSearch() {
    this.searchValue = null;
    this.searchEl?.nativeElement.focus();
    this.scrollToIndex();
  }

  showDropdown(val: boolean = true) {
    this.showItems = val;
    if (this.selectEl) {
      const position = this.selectEl.nativeElement.getBoundingClientRect().top;
      this.openPositionTop = getWindow().innerHeight - position < 240;
    }
    if (this.showItems && this.searchActive) {
      setTimeout(() => this.searchEl?.nativeElement.focus());
    }
    if (this.showItems && this.selectedItem) {
      this.scrollToIndex();
    }
  }

  selectItem(val: any) {
    this.showDropdown(false);
    this.selectedItem = val;
    this.selectControl.setValue(val.value);
    if (this.initSelectValue !== this.selectControl.value) {
      this.onBlur.emit();
      this.initSelectValue = this.selectControl.value;
    }
  }

  private scrollToIndex(indexValue = null) {
    const index = indexValue ? indexValue : this.items.findIndex((item: any) => {
      return item.code ? item.code === this.selectedItem.code : item.value === this.selectedItem.value;
    })
    setTimeout(() => {
      const el = document.getElementById('select-item-id-' + index);
      if (this.scrolledEl && el) {
        this.scrolledEl.nativeElement.scrollTop = el.offsetTop - (this.searchActive ? 100 : 45);
      }
    })
  }

}
